const vConsole = {
  error: (msg) => {
    console.log('%c ERROR :', 'background: #570303; color: white; font-size: 16px', '%c ' + msg, 'background: #f0fffc; color: white; font-size: 16px')
  },
  success: (msg) => {
    console.log('%c SUCCESS :', 'background: #40bf37; color: white; font-size: 16px', '%c ' + msg, 'background: #f0fffc; color: white; font-size: 16px')
  },
  msg: (msg) => {
    console.log('%c' + msg, 'background: #eafff7; color: black; font-size: 16px')
  },
  obj: (obj) => {
    console.log('%c OBJECT :', 'background: #eafff7; color: black; font-size: 16px')
    console.log(obj)
  }
}

const appendMyJson = (json, themeBody) => {
  const rootElement = document.createElement(json.type)
  rootElement.id = json.id

  const elements = json.inner

  themeBody.appendChild(rootElement)
  for (let i = 0, tot = elements.length; i < tot; i++) {
    const el = elements[i]
    const element = document.createElement(el.type)
    element.innerHTML = el.inner
    element.id = el.id

    rootElement.appendChild(element)
  }
}

const replaceDOM = (val, id) => {
  document.getElementById(id).textContent = val
}

const cart = {
  html: {
    type: 'div',
    id: 'gCart',
    inner: [
      {
        type: 'p',
        id: 'text',
        inner: 'siml text'
      },
      {
        type: 'ul',
        id: 'text2',
        inner: 'siml text'
      },
      {
        type: 'ul',
        id: 'items',
        inner: ''
      }
    ]
  },
  init: () => {
    vConsole.success('init')

    const initEvent = new CustomEvent('init', {
      detail: { text: 'test' }
    })
    this.dispatchEvent(initEvent)
    cart.build(this)
  },
  build: () => {
    vConsole.success('build')

    const themeBody = document.body
    const cartJson = cart.html
    appendMyJson(cartJson, themeBody)
    cart.getCart()
  },
  getCart: async () => {
    const shopifyCart = await fetch('/cart.js').then(response => response.json())
    const price = shopifyCart.total_price
    const items = shopifyCart.items

    if (items.length !== 0) {
      replaceDOM(items, 'items')
    } else {
      replaceDOM('no items', 'items')
    }

    replaceDOM(price, 'text')
  }
}

cart.init('test')
